import React, { Component } from 'react';
import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import { logoutBegin } from '../actions/LogoutActions';

class SettingsPage extends Component {

    constructor(props) {
        super(props);
        this.logout = this.logout.bind(this);
    }

    logout() {
        const { dispatch } = this.props;
        dispatch(logoutBegin());
    }


    render() {
        const { loading } = this.props;
        return (
            <Grid container>
                <Grid item xs={12}>
                    <div>
                        <button
                            id="logoutbutton"
                            className="bbe-button"
                            disabled={loading}
                            onClick={this.logout}
                            >
                        Log Out
                        </button>
                    </div>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.loading.loading
});

export default connect(mapStateToProps)(SettingsPage);